import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import zhTW from "./locales/zh_TW.json";

const storageKey = "schedule-maker.language";
let savedLanguage: string | null = null;
try { savedLanguage = localStorage.getItem(storageKey); } catch {}

const isExplicitEnglish = savedLanguage === "en";
const language = isExplicitEnglish ? "en" : "zh-TW";

// Keys are literal, flat strings: t("period.title") is directly searchable.
await i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, "zh-TW": { translation: zhTW } },
  lng: language,
  fallbackLng: "zh-TW",
  supportedLngs: ["en", "zh-TW"],
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
});

function updateDocument(language: string) {
  document.documentElement.lang = language;
  document.title = i18n.t("app.title");
}

function handleLanguageChanged(language: string) {
  updateDocument(language);
  try { localStorage.setItem(storageKey, language); } catch {}
}

updateDocument(i18n.language);
i18n.on("languageChanged", handleLanguageChanged);

export default i18n;
